import { render, staticRenderFns } from "./ContenidoCurriculaOnline.vue?vue&type=template&id=3e95da21&"
import script from "./ContenidoCurriculaOnline.vue?vue&type=script&lang=js&"
export * from "./ContenidoCurriculaOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports